import { render, staticRenderFns } from "./MerchantStatusChip.vue?vue&type=template&id=db1e09ea"
import script from "./MerchantStatusChip.vue?vue&type=script&lang=ts"
export * from "./MerchantStatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports